import axios from "axios";
import * as config from "../config";

const instance = axios.create();
const errorHandler = error => {        
    if (config.handleErrors) {
        window.location = config.rootUrl + "/error";
    }
    return Promise.reject({ ...error });
};

const successHandler = response => {    
    return response
};

instance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);


export default instance;